import Axios, { InternalAxiosRequestConfig } from 'axios';

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = getToken();
  if (token && config && config.headers) {
    config.headers.authorization = `Bearer ${token}`;
  }

  if(config.headers) {
     config.headers.Accept = 'application/json';
     config.withCredentials = false;
     config.headers['Content-Type'] = 'application/json';
  }

  return config;
}

export const axios = Axios.create({
  baseURL: `${process.env.REACT_APP_API}`,
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getToken = () => {
    return localStorage.getItem('token');
}